import { render, staticRenderFns } from "./Direction.vue?vue&type=template&id=2ec7f650&scoped=true&"
import script from "./Direction.vue?vue&type=script&lang=ts&"
export * from "./Direction.vue?vue&type=script&lang=ts&"
import style0 from "./Direction.vue?vue&type=style&index=0&id=2ec7f650&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec7f650",
  null
  
)

export default component.exports